import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import jsCookie from 'js-cookie';
import decode from 'jsonwebtoken/decode';


import useResponsive from '../../utils/hooks/useResponsive';
import useAuthenticated from '../../utils/hooks/useAuthenticated';

import navigations from '../../json/navigation.json';
import navigationsKronos from '../../json/navigation-kronos.json';

import { Navbar } from '@lifepal/lifepal-design-system';
import styles from './Navigation.module.scss';

const Navigation = () => {
  const router = useRouter();
  const { isDesktop } = useResponsive();
  const authenticated = useAuthenticated();

  const defaultNavigationMenu = [...navigations['user'], ...navigationsKronos.data];
  const [navigationMenu, setNavigationMenu] = useState(defaultNavigationMenu);
  const [initialName, setInitialName] = useState('');

  const getAuthenticatedUser = () => {
    if (authenticated) {
      const token = jsCookie.get('token');
      const user = decode(token);
      if (user && user.full_name) {
        const name = user.full_name
          .match(/(^\S\S?|\b\S)?/g)
          .join('')
          .match(/(^\S|\S$)?/g)
          .join('')
          .toUpperCase();
        if (name) {
          setInitialName(name);
        }
      }
    }
  };

  const handleLogout = () => {
    jsCookie.remove('token');
    router.push('/');
  };

  useEffect(() => {
    getAuthenticatedUser();
    let filteredNavigationMenu;
    if (authenticated) {
      filteredNavigationMenu = defaultNavigationMenu.filter((nav) => nav.title !== 'Login');
    } else {
      filteredNavigationMenu = defaultNavigationMenu.filter((nav) => nav.title !== 'Akun Saya');
    }

    setNavigationMenu(filteredNavigationMenu);
  }, []);

  return (
      <Navbar
        type={'user'}
        navigationMenu={navigationMenu}
        isAuthenticated={authenticated}
        currentActivePage={`${router.basePath}${router.asPath}`}
        isLargeScaleDisplay={isDesktop}
        handleLogout={() => handleLogout()}
        logoPath="/media/static/images/lifepal-logo.png"
        initialName={initialName !== '' ? initialName : 'LP'}
      />
  );
};

export default Navigation;
